import { Component, OnInit } from '@angular/core';
import { colors, AuthorizationSchemeService, AuthorizationScheme, MgAutocompleteData, AutocompleteDataSourceFn, getConfirmation } from '@mango/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SoortService } from 'src/app/core/service/soort.service';
import { Soort } from 'src/app/core/dto/soort';
import { Merk } from 'src/app/core/dto/merk';
import { MerkService } from 'src/app/core/service/merk.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PrijscorrectieService } from './prijscorrectie.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'prijscorrectie',
    templateUrl: './prijscorrectie.component.html',
    styleUrls: ['./prijscorrectie.component.css']
})
export class PrijscorrectieComponent {
    
    constructor(public dialog: MatDialog, private prijscorrectieService: PrijscorrectieService, private authService: AuthorizationSchemeService, private soortService: SoortService, private merkService: MerkService, private fb: FormBuilder, private snackBar: MatSnackBar, private router: Router ) {
        this.myScheme = this.authService.getMyScheme();
    }

    myScheme: AuthorizationScheme;
    PrijscorrectieFormGroup: FormGroup;
    getSoortIDDataSource: AutocompleteDataSourceFn<Soort> = MgAutocompleteData.empty();
    getMerkIDDataSource: AutocompleteDataSourceFn<Merk> = MgAutocompleteData.empty();

    ngOnInit() {

        if (!this.myScheme.canDo("CIJBorculo.Logic.PrijscorrectieRequest")) {
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
                this.router.navigateByUrl('/dashboard'));
        }

        this.PrijscorrectieFormGroup = this.fb.group({
            alles: this.fb.control(false, null),
			soortID: this.fb.control(null, null),
            merkID: this.fb.control(null, null),
            prijsStd: this.fb.control(null, null),
            prijsCY: this.fb.control(null, null),
            prijsRvA: this.fb.control(null, null),
            prijsNen: this.fb.control(null, null),
            prijsKeuring: this.fb.control(null, null),
            prijsBrl100: this.fb.control(null, null),
            prijsCrossCheck: this.fb.control(null, null),
            prijsScios: this.fb.control(null, null),
            prijsBRL6010: this.fb.control(null, null),
            prijsPool: this.fb.control(null, null),
            prijsKwestie: this.fb.control(null, null),
            prijsPoolBuiten: this.fb.control(null, null),
            prijsKwestieBuiten: this.fb.control(null, null),
		});

        this.getSoortIDDataSource = MgAutocompleteData.complex<Soort>(this.soortService, null).text('omschrijving').datasource();
        this.getMerkIDDataSource = MgAutocompleteData.complex<Merk>(this.merkService, null).text('omschrijving').datasource();


    }
 
    async Prijscorrectie(){

        let ok = await getConfirmation(this.dialog, "Prijscorrectie", "Weet u zeker dat u de prijscorrectie uit wil voeren ?");

        if (ok)        
        {
            // Set values
          let { alles, soortID, merkID, prijsStd, prijsCY, prijsRvA, prijsNen, prijsKeuring, prijsBrl100, prijsCrossCheck, prijsScios, prijsBRL6010, prijsPool, prijsKwestie, prijsPoolBuiten, prijsKwestieBuiten } = this.PrijscorrectieFormGroup.value;

            if (soortID == null && merkID == null && alles == false)  {
                this.snackBar.open(`U dient eerst een Soort of Merk te kiezen !`, 'ok', { duration: 100000 });
            } else if (this.emptyPercentages(prijsStd, prijsCY, prijsRvA, prijsNen, prijsKeuring, prijsBrl100, prijsCrossCheck, prijsScios, prijsBRL6010, prijsPool, prijsKwestie, prijsPoolBuiten, prijsKwestieBuiten)) {            
                this.snackBar.open(`Er is geen enkel percentage ingevuld !`, 'ok', { duration: 100000 }); 
            } else {
              this.prijscorrectieService.Prijscorrectie(alles, soortID, merkID, prijsStd, prijsCY, prijsRvA, prijsNen, prijsKeuring, prijsBrl100, prijsCrossCheck, prijsScios, prijsBRL6010, prijsPool, prijsKwestie, prijsPoolBuiten, prijsKwestieBuiten).toPromise().then(
                    (value) => {
                        if (value.successful) {                        
                            this.snackBar.open("De prijscorrectie is doorgevoerd! " + value.message , 'ok', { duration: 100000 }); 
                            // Refresh page (om te voorkomen dat niet per ongeluk hetzelfde nog een keer wordt gedaan)
                            this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
                            this.router.navigateByUrl('/prijscorrectie'));
                        }
                    });                                
            } 
        }   
    }

  emptyPercentages(prijsStd, prijsCY, prijsRvA, prijsNen, prijsKeuring, prijsBrl100, prijsCrossCheck, prijsScios, prijsBRL6010, prijsPool, prijsKwestie, prijsPoolBuiten, prijsKwestieBuiten)
    {
        return (
            (prijsStd == null || prijsStd == 0) && 
            (prijsCY == null || prijsCY == 0) && 
            (prijsRvA == null || prijsRvA == 0) && 
            (prijsNen== null || prijsNen == 0) && 
            (prijsKeuring == null || prijsKeuring == 0) && 
            (prijsBrl100 == null || prijsBrl100 == 0) && 
            (prijsCrossCheck == null || prijsCrossCheck == 0) && 
            (prijsScios == null || prijsScios == 0) &&
            (prijsBRL6010 == null || prijsBRL6010 == 0) && 
            (prijsPool == null || prijsPool == 0) && 
            (prijsKwestie == null || prijsKwestie == 0) &&
            (prijsPoolBuiten == null || prijsPoolBuiten == 0) &&
            (prijsKwestieBuiten == null || prijsKwestieBuiten == 0)
        );
    }
}
